import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import bg from '../Assests/bg.jpg'; // Existing image import
import tech from '../Assests/tech.jpg'; // Existing image import
import bg2 from '../Assests/Dayananda.webp'; // Existing image import

const WhoWeAre = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        height: 'auto',  // Adjust height for better responsiveness
        gridTemplateColumns: { xs: '1fr', sm: '1fr', md: '1fr 1fr' },  // Responsive columns
        gridTemplateAreas: {
          xs: `"heading" "images" "content"`, 
          sm: `"heading" "images" "content"`, // Add similar layout for tablets
          md: `"content images"`,         
        },
        alignItems: 'center',
        padding: { xs: '20px', sm: '40px', md: '50px' },  // Adjust padding for mobile, tablet, and desktop
        gap: { xs: '10px', sm: '20px', md: '30px' },
        backgroundColor: '#f8f9fa',
       
        margin: '0 auto',  // Center align the container on larger screens
      }}
    >
      {/* Heading Section - Mobile and Tablet */}
      <Box
        sx={{
          display: { xs: 'block', sm: 'block', md: 'none' },  // Show on mobile and tablet only
          gridArea: 'heading',
          textAlign: 'center',
          marginBottom: '0',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: '24px', sm: '28px' },
            fontWeight: 'bold',
            color: '#333',
          }}
        >
          Who We Are?
        </Typography>
      </Box>

      {/* Image Section */}
      <Box
        sx={{
          gridArea: 'images',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: { xs: '50px', sm: '50px', md: '100px' },
        }}
      >
     
        

        {/* Second Background Image */}
        <Box
          sx={{
            position: 'relative',
            width: { xs: '150px', sm: '200px', md: '300px' },
            height: { xs: '150px', sm: '200px', md: '300px' },
            left: { xs: '70px', sm: '50px', md: '50px' },
            marginTop: { md: '20px', xs: '40px',sm:'5px' },
            marginBottom: { xs: '-40px', sm: '-60px', md: '-80px' },
            zIndex: '1',
          }}
        >
          <img
            src={bg}
            alt="Background Tech"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '10px',
            }}
          />
        </Box>

        {/* Foreground Image */}
        <Box
          component="img"
          src={tech}
          alt="Campus Building"
          sx={{
            position: 'absolute',
            top: { xs: '60px', sm: '20px', md: '120px' },
            left: { xs: '70px', sm: '200px', md: '50px' },
            width: { xs: '150px', sm: '200px', md: '300px' },
            height: { xs: '150px', sm: '200px', md: '300px' },
            objectFit: 'cover',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: '3',
          }}
        />
      </Box>

      {/* Text Section */}
      <Box
        sx={{
          gridArea: 'content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: { xs: 'center', sm: 'center', md: 'left' },  // Center text on mobile/tablet
          padding: { xs: '10px', sm: '20px', md: '30px' },
        }}
      >
        {/* Heading - Desktop Only */}
        <Typography
          variant="h4"
          sx={{
            display: { xs: 'none', md: 'block' },
            fontSize: { md: '36px' },
            fontWeight: 'bold',
            marginBottom: '10px',
            color: '#333',
          }}
        >
          Why Choose BTech?
        </Typography>
        {/* Subheading */}
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '12px', sm: '14px', md: '18px' },
            color: '#555',
            lineHeight: '1.6', textAlign: {md: 'justify',xs:'justify',sm:'justify'},
            marginBottom: '20px',
          }}
        >
          BTech is an undergraduate program designed for students passionate about technology, engineering, and innovation. This four-year course equips students with a strong foundation in theoretical concepts and practical skills across various disciplines. With a curriculum tailored to meet industry demands, BTech programs emphasize hands-on learning, internships, and research opportunities, preparing graduates to excel in diverse fields. BTech fosters critical thinking, innovation, and creativity, preparing students to tackle complex challenges.

          
          
        </Typography>
        {/* Button */}
        <Button
          variant="contained"
          color="error"
          sx={{
            padding: '10px 20px',
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: 'bold',
            borderRadius: '5px',
            textAlign: 'center',
            width: { xs: '100%', sm: '80%', md: 'auto' },
            backgroundColor: '#981c1c',  
            '&:hover': {
              backgroundColor: '#7a1414',
            },
          }}
        >
          More About BTech Colleges Bangalore
        </Button>
      </Box>
    </Box>
  );
};

export default WhoWeAre;
